// 简单的 UUID 生成器
export function v4(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

export function v4Short(): string {
  return 'xxxxxxxx'.replace(/[x]/g, function() {
    return (Math.random() * 16 | 0).toString(16)
  })
}
